import React, { useEffect, useState } from 'react';
import { ExperienceApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import DataGrid, { Column, Paging, Pager } from 'devextreme-react/data-grid';
import { Accordion } from '../../../common/SharedComponents';
import { RuleChangesHistoryModal } from '../RuleComponents';
import moment from 'moment-timezone';

export const RuleChangeHistoryGrid = ({ ruleId, gridStore }) => {
    const experienceApi = new ExperienceApi.ExperienceApi(applicationInsights);

    const [dataStore, set_dataStore] = useState(gridStore?.store);
    const [changesHistoryIsOpen, set_changesHistoryIsOpen] = useState(false);
    const [changesHistoryId, set_changesHistoryId] = useState(null);

    const allowedPageSizes = [15, 25, 50];
    const defaultPageSize = 25;

    const dataFunction = (criteria) => {
        criteria.ruleId = ruleId;
        return experienceApi.getRuleChangeHistory(criteria);
    };

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('id', dataFunction, '');
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const showChangeDetail = (event, changeId) => {
        event.preventDefault();
        event.stopPropagation();

        set_changesHistoryId(changeId);
        set_changesHistoryIsOpen(true);
    };

    const actionCellRender = (e) => {
        return (
            <button
                id={'action_' + e.data.id}
                className='gridButton'
                title='View Audit Details...'
                onClick={(event) => showChangeDetail(event, e.data.id)}
            >
                Details
            </button>
        );
    };

    const dateAndTimeCellRender = (e) => {
        return formatDateTime(e.value);
    };

    const formatDateTime = (date) => {
        const centralTime = moment.utc(date).tz('America/Chicago');
        return `${centralTime.format('MM/DD/YYYY')} ${centralTime.format('HH:mm:ss')} CT `;
    };

    const onChangesHistoryClose = () => {
        set_changesHistoryId(null);
        set_changesHistoryIsOpen(false);
    };

    if (!ruleId) {
        return null;
    }

    return (
        <>
            <div
                className='rule accordion'
                data-accordion=''
                data-allow-all-closed='true'
                data-multi-expand='true'
            >
                <Accordion
                    title='Audit History'
                    isExpanded={true}
                    headerClass='decorated'
                >
                    <div className='card'>
                        <DataGrid
                            dataSource={dataStore}
                            showBorders={true}
                            showRowLines={false}
                            showColumnHeaders={true}
                            rowAlternationEnabled={true}
                            columnMinWidth={50}
                            columnAutoWidth={false}
                            allowSorting={true}
                            remoteOperations={true}
                            allowColumnResizing={true}
                        >
                            <Column
                                dataField='dateAndTime'
                                caption='Timestamp'
                                cellRender={dateAndTimeCellRender}
                                width={160}
                            />
                            <Column
                                dataField='userName'
                                caption='User'
                                width={120}
                                alignment='left'
                            />
                            <Column
                                dataField='reason'
                                caption='Reason'
                                width={110}
                                alignment='left'
                            />
                            <Column
                                dataField='notes'
                                caption='Notes'
                            />
                            <Column
                                alignment='center'
                                cellRender={actionCellRender}
                                width={70}
                                allowSorting={false}
                                allowResizing={false}
                            />
                            <Paging defaultPageSize={defaultPageSize} />
                            <Pager
                                showPageSizeSelector={allowedPageSizes.length > 1}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                                showInfo={true}
                            />
                        </DataGrid>
                    </div>
                </Accordion>
            </div>
            <RuleChangesHistoryModal
                isOpen={changesHistoryIsOpen}
                changeId={changesHistoryId}
                onClose={onChangesHistoryClose}
            />
        </>
    );
};
